import { put, takeLatest, select } from 'redux-saga/effects';
import { cloneDeep } from 'lodash';
import * as types from './types';
import {
  updateCanvasState,
  removeLastStackState,
  addRedoState,
  setIsContentChange,
  removeLastRedoState,
  addUndoState,
  stateManagerSelector,
} from './reducer';

export function* updateCanvasStatesSaga() {
  yield takeLatest(types.UPDATE_CANVAS_STATE_SAGA, function*(action) {
    const { stateStack } = yield select(stateManagerSelector);
    const currState = action.payload;
    const MAX_STACK = 100;
    const calcStackState =
      stateStack.length === MAX_STACK ? [...stateStack.slice(1), currState] : [...stateStack, currState];
    yield put(
      updateCanvasState({
        stateStack: calcStackState,
        currentState: currState,
      }),
    );
  });
}
export function* undoSaga() {
  yield takeLatest(types.UNDO_SAGA, function*(action) {
    const { stateStack, isContentChange } = yield select(stateManagerSelector);
    const { currState, applyState } = action.payload;
    if (stateStack.length > 0) {
      const oldStateStack = cloneDeep(stateStack);
      const newState = oldStateStack.pop(); // get next one to apply to current
      yield put(addRedoState(currState));
      applyState(newState);
      yield put(removeLastStackState());
      if (!isContentChange) yield put(setIsContentChange(true));
    }
  });
}
export function* redoSaga() {
  yield takeLatest(types.REDO_SAGA, function*(action) {
    const { redoStack, isContentChange } = yield select(stateManagerSelector);
    const { currState, applyState } = action.payload;
    if (redoStack.length > 0) {
      const oldStateStack = cloneDeep(redoStack);
      const newState = oldStateStack.pop();
      yield put(addUndoState(currState));
      applyState(newState);
      yield put(removeLastRedoState());
      if (!isContentChange) yield put(setIsContentChange(true));
    }
  });
}
